import ChatAI from 'modules/chat/components/ChatAI';

export default function ChatPage() {
  return (
      <ChatAI/>
  )
}